// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import axios from 'axios'
// import VueAxios from 'vue-axios'
import  './utils/http'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

import '../static/css/reset.css';
import '../theme/index.css'
// import '../src/assets/aliIcon/iconfont.css'


// import 'element-ui/lib/theme-chalk/index.css'


Vue.use(Vuex)
// Vue.use(VueAxios,axios);
Vue.use(ElementUI)



// import api from '../src/utils/api'
// Vue.prototype.$api = api;


Vue.config.productionTip = false


// 判断是否是登录状态
router.beforeEach((to, from, next) => {
 
  let toRouter = {
    name:to.name
  }
  let fromRouter = {
    name:from.name
  }
  //路由发生变化修改页面title
  if (to.meta.title) {  
    document.title = to.meta.title;
  }
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  if(to.matched.some(m => m.meta.requireAuth)) {
    // console.log(localStorage.getItem('token'))
    if(localStorage.getItem('TOKEN')) {
      next()
    } else{
        next({
          path: '/'    
        })　　　　　
    }　　
  } else {　　　　　　
    next()　　
  }
});

router.afterEach((to,from,next)=>{
　window,scrollTo(0,0)
})



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js